import { useState, useCallback } from 'react';
import { useNotificationSettings } from '../notifications/useNotificationSettings';
import './NotificationBanner.css';

const DISMISS_KEY = 'bloodeye_notification_banner_dismissed';

function isDismissed() {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
}

function NotificationBanner() {
    const { settings, updateSettings, supported, toggleEnabled } = useNotificationSettings();
    const [dismissed, setDismissed] = useState(isDismissed);

    const handleDismiss = useCallback(() => {
        localStorage.setItem(DISMISS_KEY, '1');
        setDismissed(true);
    }, []);

    const handleEnable = useCallback(async () => {
        const success = await toggleEnabled();
        if (success) {
            localStorage.setItem(DISMISS_KEY, '1');
            setDismissed(true);
        }
    }, [toggleEnabled]);

    // Don't show if: not supported, already dismissed, or already enabled
    if (!supported || dismissed || settings.enabled) return null;

    return (
        <div className="nb-root">
            <svg className="nb-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            <span className="nb-text">Set a daily reminder</span>
            <input
                type="time"
                className="nb-time"
                value={settings.reminderTime}
                onChange={(e) => updateSettings({ reminderTime: e.target.value })}
            />
            <button type="button" className="nb-enable" onClick={handleEnable}>
                Enable
            </button>
            <button type="button" className="nb-dismiss" onClick={handleDismiss} aria-label="Dismiss">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 6L6 18" />
                    <path d="M6 6l12 12" />
                </svg>
            </button>
        </div>
    );
}

export default NotificationBanner;
